<template>
  <div class="container container-xl margin-xl-bottom margin-xl-top l:margin-2xl-top">
    <div class="inner flex-column l:flex-row l:flex-stretch l:flex-between gap-2xl">
      <div class="side info-side flex-column gap-l">
        <div class="contact-info-block relative">
          <div
            class="bg"
            :style="`background-image:url('${getDynamicAssetUrl(
              'images/contact/contact-bg-lead-1.svg'
            )}');`"></div>
          <div class="content flex flex-middle gap-m l:gap-2xl text-m l:text-xl c-bg-1">
            <icon class="m:visible" icon="ag-phone" size="4"></icon>
            <icon class="m:hidden" icon="ag-phone" size="3"></icon>
            <span class="text-m l:text-2xl ltr">
              <a
                class="plain-link c-bg-1 ltr"
                :href="`tel:${t('ag.contact.phoneNumber')}`"
                >{{ tu("ag.contact.phoneNumberReadable") }}</a
              >
            </span>
          </div>
        </div>
        <div class="contact-info-block relative">
          <div
            class="bg"
            :style="`background-image:url('${getDynamicAssetUrl(
              'images/contact/contact-bg-lead-2.svg'
            )}');`"></div>
          <div class="content flex flex-middle gap-m l:gap-2xl text-m l:text-xl c-bg-1">
            <icon class="m:visible" icon="ag-mail" size="4"></icon>
            <icon class="m:hidden" icon="ag-mail" size="3"></icon>
            <span class="text-m l:text-2xl ltr">
              <a
                class="plain-link c-bg-1 ltr"
                :href="`mailto:${t('ag.contact.email')}`"
                >{{ tu("ag.contact.email") }}</a
              >
            </span>
          </div>
        </div>
        <div class="contact-info-block relative">
          <div
            class="bg"
            :style="`background-image:url('${getDynamicAssetUrl(
              'images/contact/contact-bg-lead.svg'
            )}');`"></div>
          <div class="content flex flex-middle gap-m l:gap-2xl text-m l:text-xl c-bg-1">
            <icon class="m:visible" icon="ag-location-pin" size="4"></icon>
            <icon class="m:hidden" icon="ag-location-pin" size="3"></icon>
            <span class="text-m l:text-2xl">{{ tu("ag.contact.address") }}</span>
          </div>
        </div>
      </div>
      <div class="form-side side text-center">
        <ag-title class="margin-auto-inline margin-m-bottom">{{
          tu("ag.contact.title")
        }}</ag-title>
        <p v-if="!contactFormComplete" class="text-center margin-2xl-bottom">
          {{ tu("ag.contact.subTitle") }}
        </p>
        <div
          v-else
          class="flex-center flex-middle gap-s width-expand margin-2xl-top text-2xl animate__FadeIn animate--faster">
          <icon-halo icon="check" theme="bg-1" halo-theme="success"></icon-halo>
          <span class="c-text">{{ tu("ag.contact.thankYouMessage") }}</span>
        </div>
        <div class="form-container">
          <base-form
            v-if="!contactFormComplete"
            v-model="contactData"
            action="agaloola/lead/basic-contact"
            method="post"
            class="max-width-400 margin-auto-inline"
            :config="contactFormConfig"
            @form:submit-success="handleSubmitSuccess"></base-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArticleItemIntro from "@/client/applications/agaloola/components/items/article/Intro.vue";
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import { useStore } from "vuex";
import { computed } from "vue";
import PageTitleBlock from "@/client/applications/agaloola/components/base/frameworks/we/AgPageTitleBlock";

export default {
  components: {},
  layout: "default",
  props: {},
  setup(props) {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props, useStore());
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "ag.contact.pageTitle",
  data: function () {
    return {
      contactFormComplete: false,
      contactData: {
        //   name: "אביחי מוזס",
        //  email: "propush123@gmail.com",
        //   content: "בדיקה 123",
      },
      contactFormConfig: {
        fields: {
          name: {
            name: "name",
            type: "text",
            label: "ag.contact.fields.name",
            validation: {
              required: {},
            },
          },
          email: {
            name: "email",
            type: "email",
            label: "ag.contact.fields.email",
            validation: {
              required: {},
              email: {},
            },
          },
          content: {
            name: "content",
            type: "textarea",
            label: "ag.contact.fields.content",
            validation: {
              required: {},
            },
          },
        },
        buttons: {
          submit: {
            type: "submit",
            theme: "alt",
            class: "margin-auto-inline width-expand margin-xl-top",
            text: "ag.contact.submitCta",
            "icon-end": "chevron-inline-end",
          },
        },
      },
    };
  },
  methods: {
    handleSubmitSuccess(res) {
      console.log("res");
      this.contactFormComplete = true;
    },
  },
};
</script>

<style scoped lang="scss">
.side {
  flex: 100%;
}

.info-side {
  flex: 0 0 512px; // matches graphics
  max-width: 100%;

  @media (max-width: 1024px) {
    order: 2;
    align-items: center;
    width: 512px;
    height: auto;
    margin-inline: auto;
  }
}

.contact-info-block {
  position: relative;
  padding: calc(var(--margin-xl) * 1.3);
  padding-inline-end: var(--margin-max);
  background-size: 100% 100%;
  background-position: 0% 0%;
  background-repeat: no-repeat;
  max-width: 512px;

  @media (max-width: 1024px) {
    width: 512px;
  }

  @media (max-width: 767px) {
    padding: calc(var(--margin-xl) * 1) calc(var(--margin-m) * 1);
    max-width: 300px;
    height: 90px;
  }

  .bg {
    position: absolute;
    top: 0;
    inset-inline-start: 0;
    width: 100%;
    height: 100%;
    z-index: var(--z-1);
    max-width: 512px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .content {
    position: relative;
    z-index: var(--z-2);

    @media (max-width: 767px) {
      line-height: 0;
      position: absolute;
      top: 50%;
      inset-inline-start: 50%;
      transform: translatey(-50%) translateX(50%);
      width: 100%;
      padding-inline: var(--margin-l);
    }
  }
}
</style>
